import useAccess from '@/composables/access/access';
import { accessGroupFlag, viewApplication } from 'shared/constants.json';
import { computed } from 'vue';

export default function useViewRights(readOnly) {
  const { userHasRight } = useAccess();
  const hasPublicViewAccess = computed(() => userHasRight([accessGroupFlag.publicSavedViews]));
  const canEdit = (view) => {
    if (readOnly) {
      return false;
    }

    if (!view.isPublic) {
      return true;
    }

    return hasPublicViewAccess.value || ![
      viewApplication.goal,
      viewApplication.update,
      viewApplication.updateFeed,
      viewApplication.goalAccount,
      viewApplication.updateAccount,
      viewApplication.updateFeedAccount,
    ].includes(view.viewApplication);
  };

  return { canEdit };
}
